import { DEFAULT_OPTION } from '@/fsd/feature/cashbox/paginate-cashbox-item/model/consts/const';
import {
  IPageSizeSelectOption,
  PageSizeSelect,
} from '@/fsd/shared/ui/PageSizeSelect';
import styles from './PaginateBankItemPageSize.module.scss';

interface IProps {
  page_size: number;
  handlePageSizeChange: (pageSize: number) => void;
}

const PaginateBankItemPageSize = ({
  page_size,
  handlePageSizeChange,
}: IProps) => {
  const handleOptionChange = (option: IPageSizeSelectOption) => {
    handlePageSizeChange(option.value);
  };

  return (
    <div className={styles.wrapper}>
      <p className={styles.title}>Строк на странице</p>
      <PageSizeSelect
        defaultOption={DEFAULT_OPTION}
        value={String(page_size)}
        fieldName={'value'}
        onOptionChange={handleOptionChange}
        openDirection="top"
      />
    </div>
  );
};

export default PaginateBankItemPageSize;
